var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"add-to-locker-button",class:{
    disabled: _vm.isLockerLoading || _vm.isProjectLocked,
    'dealer-mode': _vm.dealerMode,
    'is-snapsheet': _vm.isSnapsheet,
  },attrs:{"disabled":_vm.isLockerLoading || _vm.isProjectLocked},on:{"click":function($event){return _vm.$emit('addToLocker')}}},[_c('img',{attrs:{"src":require("@/assets/icons/ui/add-to-locker.png"),"alt":"add to locker"}})])}
var staticRenderFns = []

export { render, staticRenderFns }